import { Box, modeColor } from '@talos/kyoko';
import styled from 'styled-components';

export const AppInboxToastWrapper = styled(Box)<{ addShadow?: boolean }>`
  ${({ theme, addShadow }) => `
    pointer-events: auto;
    border-radius: ${theme.borderRadiusDefault}px;
    ${addShadow ? `box-shadow: 0 5px 40px ${modeColor(theme, 'hsla(0, 0%, 0%, 0.1)', theme.colors.black.dim)};` : ''}
    div {
      word-break: break-word;
    }
  `}
`;
